import { useEffect, useMemo, useState } from 'react';

import { fetchTranslations } from './translationsService';
import { LocaleKeyEnum } from '../../types';

const localeToShortCode: Record<LocaleKeyEnum, string> = {
  [LocaleKeyEnum.deDE]: 'de',
  [LocaleKeyEnum.enUS]: 'en',
  [LocaleKeyEnum.frFR]: 'fr',
  [LocaleKeyEnum.itIT]: 'it',
  [LocaleKeyEnum.plPL]: 'pl',
  [LocaleKeyEnum.csCZ]: 'cs',
};

export function useTranslations(locale: LocaleKeyEnum) {
  const [apiTranslations, setApiTranslations] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const shortCode = localeToShortCode[locale];
    if (!shortCode) return;

    fetchTranslations(shortCode)
      .then((translations) => {
        setApiTranslations(translations);
      })
      .catch(() => {
        setApiTranslations({});
      })
      .finally(() => {
        setLoading(false);
      });
  }, [locale]);

  const messages = useMemo(() => {
    return { ...apiTranslations };
  }, [locale, apiTranslations]);

  return {
    messages,
    loading,
  };
}
